import { tv } from 'tailwind-variants';
export const modal = tv({
    base: 'relative overflow-auto rounded-16 bg-background-overlay p-24 dark:bg-background-overlay-dark',
});
export const modalTitleContainer = tv({
    base: 'z-[1] flex w-full items-center',
    variants: {
        justifyContent: {
            true: 'justify-between',
            false: 'justify-end',
        },
        marginBottom: {
            true: 'mb-16',
            false: 'mb-8',
        },
    },
});
export const modalTitle = tv({
    base: 'flex flex-1 flex-row justify-center px-4',
    variants: {
        alignItems: {
            true: 'items-center',
            false: 'items-start',
        },
    },
});
export const PREVIOUS_ACTION_EMPTY_SPACING = '--previous-action-empty-spacing';
